<h3>{{ title }}</h3>
<tk-button-group>
	<tk-button theme="primary" (click)="submitForm()">{{ btnText }}</tk-button>
	<tk-button theme="secondary" (click)="closeModal()">Отменить</tk-button>
</tk-button-group>
